import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Attachments_search extends PureComponent {
  render() {
    return (
      <div className="row" id="attachments_search">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Attachments</h2>
              <p>
                Attachments are locked to an individual record. To get a list of
                attachments a user needs to have read access to that record and
                file download permission.
              </p>
              <p>
                Attachment searching works the same as record searching. Like
                the record search function the attachment search function
                includes options like query, sort, size etc.
              </p>
              <p>
                The attachment search results include an AWS S3 signed URL which
                is valid for 1 hour.
              </p>
              <p>
                AWS S3 does not have a file ID in the same way as other Nexoid
                records instead they use a file key. This Search function
                translates the File Key to a “path”. The path parameter is
                typically 16 random characters followed by a forward slash and
                the original file name. Because files in the S3 cannot be
                renamed there is an additional parameter called “file”. The file
                parameter represents the name of the file in the interface and
                when it is downloaded the file parameter can be changed through
                the attachment rename function.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Search Attachments Example</h2>
              <p>
                This example we return attachments for the record with ID 999.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">999</span>/attachments/search
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"took"</span>:{" "}
                  <span className="jsonP">2</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"total"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"attachments"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"key"</span>:{" "}
                  <span className="jsonY">"8t23momxa0lnxc4x/photo123.jpg"</span>
                  ,
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"photo.jpg"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"last_modified"</span>:{" "}
                  <span className="jsonY">"2017-17-29T18:41:00.640Z"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"size"</span>:{" "}
                  <span className="jsonP">243016</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"link"</span>:{" "}
                  <span className="jsonY">
                    "https://nexoid-users-example.s3.example.amazonaws.com/example/851/record/data_object/999/8t23momxa0lnxc4x/photo123.jpg?AWSAccessKeyId=AMIAIKHGCGKNMHX42O5R&amp;Expires=1445325171&amp;Signature=zpMZNr7pddyOCzm%2B2y6WwMMKurE%3D&amp;response-content-disposition=attachment%3B%20filename%20%3D%22photo.jpg%22"
                  </span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">]</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Attachments_search;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Attachments_search.js